import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZDrawEntry } from './models';

const c = initContract();
export const authDrawContract = c.router(
  {
    getDrawEntriesWithRealAndHypotheticalPrizes: {
      method: 'GET',
      path: '/results-reveal/entries-with-real-and-hypothetical-prizes/:draw_id',
      pathParams: z.object({
        draw_id: z.coerce.number(),
      }),
      responses: {
        200: z.array(ZDrawEntry),
      },
    },
    getPlayersUpcomingDrawDate: {
      method: 'GET',
      path: '/upcoming-draw-date',
      responses: {
        200: z.object({
          upcomingDrawDate: z.coerce.date().nullable(),
        }),
      },
    },
  },
  {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
